import Component from "@glimmer/component"

interface Signature {
  Args: {
    title: string
    goBack: () => void
  }
}

export default class AddGCPostTitle extends Component<Signature> {}
declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Menus::AddCard::GoogleClassroomPost::Title": typeof AddGCPostTitle
  }
}
